import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, obj = user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip /me — AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (_e) {
      setUser(false);
      localStorage.removeItem("pulse_token");
      localStorage.removeItem("pulse_user");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setAuthedUser = (u, token) => {
    if (token) localStorage.setItem("pulse_token", token);
    localStorage.setItem("pulse_user", JSON.stringify(u));
    setUser(u);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_e) {
      /* noop */
    }
    localStorage.removeItem("pulse_token");
    localStorage.removeItem("pulse_user");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setAuthedUser, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
